<template>
    <div class="d-flex flex-column align-items-center text-center">
        <b-form-group
                id="notes-form"
                label="🤷🏻‍♂️Рекомендации производителя работ "
                label-class="label-class"
                class="w-75 mt-5"
        >
            <AppTextarea
                    id="textarea"
                    v-model="notes"
                    placeholder="Тут можно указать ваши замечания или предложения по увеличению производительности работ. Данная информация будет направлена куратору объекта."
            ></AppTextarea>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "StepSix",
    computed: {
        notes: {
            get() {
                return this.$store.state.shiftReport.notes;
            },
            set(v) {
                this.$store.commit(`shiftReport_setNotes`, v);
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        }
    },
    mounted() {
        this.$emit(`can-continue`, {
            value: true
        });
    }
}
</script>

<style scoped>

#textarea::placeholder {
  color: #6c757d;
  opacity: 0.3;
}

</style>